import { render, staticRenderFns } from "./CompanySocialMedia.vue?vue&type=template&id=401d9056"
import script from "./CompanySocialMedia.vue?vue&type=script&lang=js"
export * from "./CompanySocialMedia.vue?vue&type=script&lang=js"
import style0 from "./CompanySocialMedia.vue?vue&type=style&index=0&id=401d9056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports